import { DbListBase } from "./db-list-base";
import { DbObjectBase } from "./db-object-base";
import { TaskQueue } from "../../../core/_shared/models/task-queue.model";
import { Printer } from '../../../core/_shared/models/printer.model';
import { ICollectionReference } from '../database-cast/IDatabase';
import { Evaluation, License } from '../../_shared/models/Customer';


export class DbCustomerTask extends DbObjectBase<TaskQueue>
{
    constructor(id: string, colllection: ICollectionReference)
    {
        super(id,colllection);
    }
}


export class DbCustomerFinishedTasks extends DbListBase<TaskQueue> {
  getTask(id: string) {
    
    return new DbCustomerTask(id,this._collection);
  }

  
    constructor(collection: ICollectionReference) {
        super(collection);
       
    }

}

export class DbCustomerArchivedTasks extends DbListBase<TaskQueue> {
    getTask(id: string) {
      
      return new DbCustomerTask(id,this._collection);
    }
  
    
      constructor(collection: ICollectionReference) {
          super(collection);
         
      }
  
  }

export class DbCustomerTaskProcessing extends DbObjectBase<any>
{
    constructor(id: string, colllection: ICollectionReference)
    {
        super(id,colllection);
    }

    getTasks():DbCustomerTasks
    {
        return new DbCustomerTasks(this._docReference.collection("tasks"));
    }
}



export class DbCustomerTasks extends DbListBase<TaskQueue> {
  

    getProcessing(): DbCustomerTaskProcessing {
        return new DbCustomerTaskProcessing("processing",this._collection);
      }
  
      
  public   getTask(id: string): DbCustomerTask {
    return new DbCustomerTask(id,this._collection);
  }


    constructor(collection: ICollectionReference) {
        super(collection);
    }


    public addTask(task: TaskQueue): Promise<TaskQueue> {

        let promise = new Promise<TaskQueue>((resolve, reject) => {


            let objTask =JSON.parse( JSON.stringify(task));

         

            this._collection.add(objTask)
                .then(docReference => {
             
                    task.id = docReference.id;
                    resolve(task);
                }).
                catch(error => {

             
                    reject(error);

                });
        });


        return promise;
    }


}


export class DbCustomerPrinters extends DbListBase<Printer> {


    constructor(collection: ICollectionReference) {
        super(collection);
    }

  getPrinter(id:string) {
    return new DbCustomerPrinter(id,this._collection);
  }
}

export class DbCustomerLicenses extends DbListBase<License> {


    constructor(collection: ICollectionReference) {
        super(collection);
    }

  getLicense(id:string) {
    return new DbCustomerLicense(id,this._collection);
  }
}

export class DbCustomerEvaluations extends DbListBase<Evaluation> {


    constructor(collection: ICollectionReference) {
        super(collection);
    }

  getEvaluation(id:string) {
    return new DbCustomerEvaluation(id,this._collection);
  }
}


export class DbCustomerPrinter extends DbObjectBase<Printer> {

    constructor(betId: string, collection: ICollectionReference) {

        super(betId,collection);

    }

}
    export class DbCustomerLicense extends DbObjectBase<License> {

        constructor(id: string, collection: ICollectionReference) {
    
            super(id,collection);
    
        }

}

export class DbCustomerEvaluation extends DbObjectBase<Evaluation> {

    constructor(id: string, collection: ICollectionReference) {

        super(id,collection);

    }

}
